import type { PartIntervalListQuery, PartReplacementIntervalView } from '@chukua/common';
import { Tag, Tooltip, type TableColumnsType } from 'antd';
import { Link } from 'react-router';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import { partTypePath } from '../../part-types/part-types.paths';
import { describeExpectedLife, formatFittedDate, formatIntervalDays, formatIntervalKm } from '../policies/part-labels';

/** Each sortable column's `key` is its sort field in `partIntervalListQuerySchema`. */
export function buildIntervalColumns({
  list,
}: {
  list: Pick<ListQueryControls<PartIntervalListQuery>, 'sortOrderFor'>;
}): TableColumnsType<PartReplacementIntervalView> {
  return [
    {
      title: 'Part type',
      dataIndex: 'partTypeName',
      key: 'partTypeName',
      sorter: true,
      sortOrder: list.sortOrderFor('partTypeName'),
      render: (name: string, row) => <Link to={partTypePath(row.partTypeId)}>{name}</Link>,
    },
    { title: 'Fitted', dataIndex: 'replacedFittedAt', key: 'replacedFittedAt', render: formatFittedDate },
    {
      title: 'Replaced',
      dataIndex: 'replacedByFittedAt',
      key: 'fittedAt',
      sorter: true,
      sortOrder: list.sortOrderFor('fittedAt'),
      render: formatFittedDate,
    },
    { title: 'Lasted (time)', dataIndex: 'days', key: 'days', sorter: true, sortOrder: list.sortOrderFor('days'), render: formatIntervalDays },
    { title: 'Lasted (distance)', dataIndex: 'km', key: 'km', sorter: true, sortOrder: list.sortOrderFor('km'), render: formatIntervalKm },
    {
      title: 'Life',
      key: 'isShort',
      render: (_, row) => (
        <Tooltip title={describeExpectedLife(row)}>
          <Tag color={row.isShort ? 'error' : 'default'}>{row.isShort ? 'Short' : 'Normal'}</Tag>
        </Tooltip>
      ),
    },
  ];
}
